import { Spinner } from "../atoms/Spinner/Spinner.js";

/**
 * Task 15 — who else is typing, as one small muted line immediately above the
 * composer. The line's height is RESERVED whenever it is rendered, so names
 * appearing, changing or clearing never move the thread or the composer. It
 * says nothing about Player AI, whose own activity has its own indicator.
 */
export function ComposerTypingLine({ names }: { names: readonly string[] }) {
  const label = typingLabel(names);
  return (
    <div
      data-composer-typing
      aria-live="polite"
      className="-mt-1 mb-1 flex h-4 min-w-0 items-center gap-1.5 px-1 text-dense-2 text-pb-text-muted"
    >
      {label ? (
        <>
          <Spinner variant="dots" size="xs" aria-hidden className="shrink-0" />
          <span className="min-w-0 truncate">{label}</span>
        </>
      ) : null}
    </div>
  );
}

/**
 * "Eddie is typing…", "Eddie and Sarah are typing…", "Eddie and 2 others are
 * typing…". Names arrive de-duplicated per person and never include the
 * viewer; an empty list says nothing.
 */
export function typingLabel(names: readonly string[]): string {
  const [first, second] = names;
  if (first === undefined) return "";
  if (second === undefined) return `${first} is typing…`;
  if (names.length === 2) return `${first} and ${second} are typing…`;
  return `${first} and ${names.length - 1} others are typing…`;
}
